function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { CompanionProvider, CompanionProviderMap } from '../../../addons/adverts/common';
function processAttributes(attributes) {
    var width = attributes.width, height = attributes.height, assetWidth = attributes.assetWidth, assetHeight = attributes.assetHeight, expandedWidth = attributes.expandedWidth, expandedHeight = attributes.expandedHeight, pxratio = attributes.pxratio, rest = _object_without_properties(attributes, [
        "width",
        "height",
        "assetWidth",
        "assetHeight",
        "expandedWidth",
        "expandedHeight",
        "pxratio"
    ]);
    var processedAttributes = _object_spread_props(_object_spread({}, rest), {
        width: parseInt(width, 10),
        height: parseInt(height, 10)
    });
    processedAttributes.assetWidth = parseInt(assetWidth, 10) || undefined;
    processedAttributes.assetHeight = parseInt(assetHeight, 10) || undefined;
    processedAttributes.expandedWidth = parseInt(expandedWidth, 10) || undefined;
    processedAttributes.expandedHeight = parseInt(expandedHeight, 10) || undefined;
    processedAttributes.pxratio = parseInt(pxratio, 10) || undefined;
    return processedAttributes;
}
function processTacking(tracking) {
    var trackingEvents = [];
    tracking.forEach(function(track) {
        track.beaconUrls.forEach(function(url) {
            trackingEvents.push({
                type: track.eventType,
                url: url
            });
        });
    });
    return trackingEvents;
}
export function mapCompanionAds(companions) {
    var ads = [];
    if (companions) {
        companions.forEach(function(companion) {
            var adSlotId = companion.attributes.adSlotId;
            var provider = CompanionProviderMap[adSlotId];
            switch(provider){
                case CompanionProvider.Brightline:
                    {
                        var attributes = processAttributes(companion.attributes);
                        var url = companion.iFrameResource || companion.staticResource;
                        var tracking = processTacking(companion.trackingEvents);
                        ads.push({
                            provider: CompanionProvider.Brightline,
                            attributes: attributes,
                            url: url,
                            tracking: tracking
                        });
                        break;
                    }
                default:
                    return;
            }
        });
    }
    return ads;
}

//# sourceMappingURL=media-tailor-companions.js.map